<nv-header *ngIf="showHeader"></nv-header>
<nv-container>
  <div class="text-center">
    <i class="fad fa-mug-hot"></i>
    <p class="mt-3">
      <strong [innerHtml]="'CONSTRUCTION_PAGE.TEXT' | translate"> </strong>
    </p>
  </div>
</nv-container>
